import { StyleSheet } from 'react-native';
import { pt } from '../../common/utils';

export default StyleSheet.create({
    banner: {
    // height: pt(420),
        width: pt(375),
        backgroundColor: '#FF4F18',
        flex: 1
    },
    over: {
        zIndex: 1,
        overflow: 'hidden'
    },
    top: {
        flexDirection: 'row',
        marginBottom: pt(5),
        height: pt(63),
        justifyContent: 'space-between',
        borderTopLeftRadius: pt(40),
        borderTopRightRadius: pt(40)
    },
    left: {
        height: '100%',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center'
    },
    logo: {
        height: pt(47),
        width: pt(47),
        marginLeft: pt(5)
    },
    text: {
        fontSize: pt(24),
        color: '#fff',
        fontWeight: 'bold',
        marginLeft: pt(4),
        marginTop: pt(-2)
    },
    close_touch: {
        height: pt(50),
        width: pt(50),
        marginTop: pt(12),
        paddingTop: pt(5),
        paddingLeft: pt(20)
    // zIndex: 1
  },
  close: {
    width: pt(20),
    height: pt(20),
  },
  banner_circle1: {
    width: pt(18),
    height: pt(18),
    borderRadius: pt(9),
    backgroundColor: '#FAD961',
    position: 'absolute',
    top: pt(3),
    left: pt(191),
    opacity: 0.2
  },
  banner_circle2: {
    width: pt(64),
    height: pt(64),
    borderRadius: pt(32),
    backgroundColor: '#FAD961',
    position: 'absolute',
    top: pt(38),
    left: pt(200),
    opacity: 0.2
  },
  banner_circle3: {
    width: pt(150),
    height: pt(150),
    borderRadius: pt(75),
    backgroundColor: '#FAD961',
    position: 'absolute',
    top: pt(-30),
    left: pt(245),
    opacity: 0.3
  },
  list: {
    width: pt(355),
    // height: pt(386),
    // height: innerHeight*(0.58),
    backgroundColor: '#fff',
    borderRadius: pt(3),
    marginLeft: pt(10),
    marginBottom: pt(15),
    paddingBottom: pt(20)
  },
  list_top: {
    marginLeft: pt(17),
    marginTop: pt(17),
    flexDirection: 'row'
  },
  list_top_left: {
    width: pt(60),
    height: pt(88),
    borderRadius: pt(2),
    marginRight: pt(16)
  },
  list_top_right_top: {
    flexDirection: 'row',
    marginBottom: pt(3),
    marginTop: pt(5)
  },
  movie_name: {
    fontSize: pt(14),
    fontWeight: 'bold',
    marginRight: pt(8)
  },
  movie_type_one_wrap: {
    paddingHorizontal: pt(3),
    borderRadius: pt(3),
    backgroundColor: '#898989'
  },
  movie_type_one: {
    fontSize: pt(11),
    color: '#fff',
    backgroundColor: 'transparent'
  },
  movie_type_left: {
    height: pt(15),
    fontSize: pt(11),
    paddingHorizontal: pt(3),
    borderTopLeftRadius: pt(3),
    borderBottomLeftRadius: pt(3),
    color: '#fff',
    backgroundColor: '#898989',
  },
  movie_type_right: {
    height: pt(15),
    fontSize: pt(11),
    paddingHorizontal: pt(3),
    color: '#898989',
    backgroundColor: '#fff',
    borderTopRightRadius: pt(3),
    borderBottomRightRadius: pt(3),
    borderWidth: 1,
    borderColor: '#979797'
  },
  list_top_right_score: {
    color: '#FFAE18',
    fontSize: pt(10),
    height: pt(14),
    marginBottom: pt(8),
    fontWeight: 'bold'
  },
  list_top_right_dir: {
    fontSize: pt(12),
    color: '#666666',
    width: pt(126),
    height: pt(17),
    marginBottom: pt(2)
  },
  list_top_right_main: {
    fontSize: pt(12),
    color: '#666666',
    width: pt(192),
    height: pt(17)
  },
  place: {
    marginLeft: pt(16),
    marginTop: pt(29),
    marginBottom: pt(10),
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  place_left: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-around',
  },
  place_left_left: {
    marginRight: pt(7),
    fontSize: pt(14),
    color: '#000',
    fontWeight: 'bold',
  },
  place_left_right: {
    marginTop: pt(2),
    width: pt(4),
    height: pt(10)
  },
  place_right: {
    marginRight: pt(12),
    fontSize: pt(13),
    color: '#898989',
  },
  content: {
    marginTop: pt(2),
    // flexDirection: 'row',
    paddingRight: pt(10)
  },
  content_content: {
    width: pt(74),
    height: pt(75),
    backgroundColor: '#F5F7F8',
    // marginLeft: pt(17),
    borderRadius: pt(2),
    justifyContent: 'center',
    // alignItems: 'flex-start',
    alignItems: 'center',
    // paddingLeft: pt(15)
  },
  content_content_left: {
    fontSize: pt(16),
    color: '#252525',
    // marginTop: pt(8),
    // marginLeft: pt(12)
    },
    content_content_mid: {
        fontSize: pt(10),
        color: '#898989',
        marginBottom: pt(3)
    // marginLeft: pt(12)
    },
    content_content_right: {
        flexDirection: 'row',
        justifyContent: 'center',
        // width: pt(50),
        alignItems: 'center'
    // paddingLeft: pt(2)
    },
    content_content_right_left: {
        fontSize: pt(12),
        color: '#E2231A'
    // marginLeft: pt(12),
  },
  priceRise: {
    fontSize: pt(8),
    color: '#999999',
  },
  content_hui: {
    width: pt(12),
    height: pt(11),
    backgroundColor: '#F56A00',
    borderRadius: pt(2),
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: pt(1)
  },
  content_content_right_right: {
    color: '#fff',
    fontSize: pt(8)    
  },
  content_content_sp: {
    width: pt(66),
    height: pt(71),
    backgroundColor: '#F5F7F8',
    marginLeft: pt(17),
    borderRadius: pt(2)
  },
  content_content_plus: {
    width: pt(30),
    height: pt(15)
  },
  content_content_left_sp: {
    fontSize: pt(16),
    color: '#252525',
    marginLeft: pt(12)
  },
  content_content_mid_sp: {
    fontSize: pt(10),
    color: '#898989',
    marginBottom: pt(1),
    marginLeft: pt(12)
  },
  content_content_right_sp: {
    fontSize: pt(12),
    color: '#E2231A',
    marginLeft: pt(12)
  }
});
